export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Biology and science teachers in middle school, high school, introductory college and homeschool who teach DNA, heredity and genetics.',
  ],
  [
    'Content depth?',
    'From the DNA molecule to gene expression, inheritance, mutations, biotechnology, CRISPR, evolution and bioethics, with diagrams, worked examples and common student misconceptions.',
  ],
  [
    'International?',
    'Yes. Written in English using internationally used scientific terminology; adapt it to your own curriculum and classroom.',
  ],
  ['Format?', 'Professional PDF files with instant access.'],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
